import Vue from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Login from '../components/Login'
import Signup from '../components/Signup/Signup'
import PersonalInformation from '../components/Signup/PersonalInformation'
import MailAndPassword from '../components/Signup/MailAndPassword'
import InfoWallet from '../components/Signup/InfoWallet'
import Identity from '../components/Signup/Identity'
import Main from '../views/Main'
import BuyToken from '../views/BuyToken'
import GenericAlert from '../components/GenericAlert'
import EstatesMap from '../components/EstatesMap'
import EstatesList from '../components/EstatesList'
import Wallet from '../components/Wallet'
import Authentication from '../views/Authentication'
import EstateDetails from '../components/EstateDetails'
import Info from '../components/EstateDetails/Info'
import Cost from '../components/EstateDetails/Cost'
import Documents from '../components/EstateDetails/Documents'
import Trade from '../components/EstateDetails/Trade'
import Chat from '../components/EstateDetails/Chat'
import GlobalVariables from '../components/GlobalVariables'
import Loader from '../components/Loader'
import Exchange from '../components/Exchange'
import BottomNavigation from '../components/BottomNavigation'


export const registerComponents = () => {
	Vue.component ('vue-fontawesome', FontAwesomeIcon)
	Vue.component ('authentication', Authentication)
	Vue.component ('login', Login)
	Vue.component ('signup', Signup)
	Vue.component ('personal-information', PersonalInformation)
	Vue.component ('mail-and-password', MailAndPassword)
	Vue.component ('info-wallet', InfoWallet)
	Vue.component ('identity', Identity)
	Vue.component ('main-view', Main)
	Vue.component ('generic-alert', GenericAlert)
	Vue.component ('estates-map', EstatesMap)
	Vue.component ('estates-list', EstatesList)
	Vue.component ('wallet', Wallet)
	Vue.component ('estate-details', EstateDetails)
	Vue.component ('estate-details-info', Info)
	Vue.component ('estate-details-documents', Documents)
	Vue.component ('estate-details-cost', Cost)
	Vue.component ('estate-details-trade', Trade)
	Vue.component ('estate-details-chat', Chat)
	Vue.component ('global-variables', GlobalVariables)
	Vue.component ('buy-token', BuyToken)
	Vue.component ('loader', Loader)
	Vue.component ('exchange', Exchange)
	Vue.component ('bottom-navigation', BottomNavigation)
}

export *  from './firebase'